import styled from 'styled-components'
import Typography from '~components/dumbs/Typography'
import { LabelProps } from './interface'

export const Radio = styled.input.attrs({ type: 'radio' })`
  accent-color: ${({ theme }) => theme.brand.icon.default};
  cursor: pointer;
`

export const Wrapper = styled.div`
  input[type='radio']:checked + label {
    color: ${({ theme }) => theme.neutral.text.strong};
  }
  padding-bottom: ${({ theme }) => theme.spacing.km3};
  padding-top: ${({ theme }) => theme.spacing.km3};
  :not(:last-child) {
    margin-bottom: ${({ theme }) => theme.spacing.km2};
  }
  display: flex;
  align-items: center;
`

export const Label = styled(Typography).attrs({ as: 'label' })<LabelProps>`
  color: ${({ theme }) => theme.neutral.text.default};
  font-size: ${({ theme }) => theme.font.size.m3};
  line-height: ${({ theme }) => theme.font.lineHeight.small};
  font-weight: ${({ theme }) => theme.font.weight.regular};
  padding-left: ${({ theme }) => theme.spacing.km3};
  user-select: none;
  white-space: nowrap;
  cursor: pointer;
`
